module.exports = "images/doc-client-add.42a85f27fb5492fda159f42a6ff8d50c.png";